import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { BridgeConstants } from '../../../../../shared/configs/bridge-constants.config';
import { CubeService } from '../../../../../services/cube/cube.service';

@Component({
  selector: 'cube-duplicate-campata-dialog',
  templateUrl: './duplicate-campata-dialog.component.html',
  styleUrls: ['./duplicate-campata-dialog.component.scss'],
  standalone: false,
})
export class DuplicateCampataDialogComponent implements OnInit {
  availableCampataNoList: any[];
  bridgeConstants: typeof BridgeConstants = BridgeConstants;
  campataForm: FormGroup;
  existingCampateList: any[];

  private selectedIndex: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) private matDialogData: any,
    private cubeService: CubeService,
    private formBuilder: FormBuilder,
    private matDialogRef: MatDialogRef<DuplicateCampataDialogComponent>
  ) {
    this.existingCampateList = this.matDialogData.existingCampateList;
    this.selectedIndex = this.matDialogData.selectedIndex;
    this.campataForm = this.createForm();
  }

  ngOnInit(): void {
    this.availableCampataNoList = this.createAvailableCampataNoList();
  }

  onClickCloseDialog(): void {
    this.matDialogRef.close();
  }

  onSubmitForm(): void {
    const elementListNames = [
      `${BridgeConstants.levels.spalle}list`,
      `${BridgeConstants.levels.pile}list`,
      `${BridgeConstants.levels.archi}list`,
      `${BridgeConstants.levels.impalcati}list`,
      `${BridgeConstants.levels.fileDiAppoggi}list`,
      `${BridgeConstants.levels.giunti}list`,
      `${BridgeConstants.levels.apparecchiSismici}list`,
    ];
    const { newCampataNo, selectedCampataNo } = this.campataForm.value;
    const selectedCampata = this.existingCampateList.find(
      (campata) => campata[BridgeConstants.partNo] === selectedCampataNo
    );
    const duplicateCampata = this.cubeService.getDeepCopy(selectedCampata);

    // Update Campata No. in all locations
    elementListNames.forEach((listName) => {
      duplicateCampata[BridgeConstants.partNo] = newCampataNo;
      duplicateCampata.modelstructure[BridgeConstants.partNo] = newCampataNo;

      // Inside each element
      duplicateCampata.modelstructure[listName].forEach((element) => {
        // Campata No
        element.modelstructure[BridgeConstants.partNo] = newCampataNo;

        // Campata No
        element.modelstructure['Scheda Ispezione Ponti di Livello 1'][
          BridgeConstants.partNo
        ] = newCampataNo;

        // Updating Sigla ID Elem
        const siglaIdElemParts =
          element.modelstructure['Scheda Ispezione Ponti di Livello 1'][
            'Sigla ID Elem'
          ].split('-');
        siglaIdElemParts[0] = siglaIdElemParts[0].replace(/\d+/, newCampataNo);
        element.modelstructure['Scheda Ispezione Ponti di Livello 1'][
          'Sigla ID Elem'
        ] = siglaIdElemParts.join('-');

        // Updating generated defect file names
        const defectsList: any[] =
          element.modelstructure['Scheda Ispezione Ponti di Livello 1'][
            'Scheda Ispezione Ponti di Livello 1 List1'
          ];
        defectsList.forEach((defectRow, defectRowIndex) => {
          // INFO: Similar functionality is also used in duplicateDefect() and in duplicateIndexedDbFiles() in bridge-input-template.component.ts file
          if (
            defectRow['Codice difetto'] === BridgeConstants.eventualiNote
              ? !Object.keys(defectRow.Note).length
              : !defectRow['N° foto']
          )
            return;

          // If defect has files
          const updatedNFoto = '';
          const key =
            defectRow['Codice difetto'] === BridgeConstants.eventualiNote
              ? 'Note'
              : 'N° foto';
          /* // INFO: Commenting as per RINA-6309
          const nFotoValues = Object.entries(defectRow[key]);
          nFotoValues.forEach(([fotoKey, foto]) => {
            const nameParts = fotoKey.split(' ');
            this.fotoCount++;
            nameParts[1] = this.fotoCount.toString();
            fotoKey = nameParts.join(' ');
            updatedNFoto[fotoKey] = foto;
          }); */

          element.modelstructure['Scheda Ispezione Ponti di Livello 1'][
            'Scheda Ispezione Ponti di Livello 1 List1'
          ][defectRowIndex][key] = updatedNFoto;
        });

        /* // INFO: Commenting as per RINA-6309
        this.inspectionService.setImageCount$(this.fotoCount); */
      });
    });

    this.matDialogRef.close({
      duplicateCampata,
      selectedCampataNo,
    });
  }

  private createAvailableCampataNoList(): any[] {
    const availableCampataNoList = this.matDialogData.campateNoList.filter(
      ({ value: camapteNo }) => {
        const isCampataAlreadyAdded = this.existingCampateList.some(
          (existingCampata) =>
            existingCampata[BridgeConstants.partNo] === camapteNo
        );

        return !isCampataAlreadyAdded;
      }
    );

    return availableCampataNoList;
  }

  private createForm(): FormGroup {
    return this.formBuilder.group({
      newCampataNo: [null, [Validators.required]],
      selectedCampataNo: [
        this.existingCampateList[this.selectedIndex][BridgeConstants.partNo],
        [Validators.required],
      ],
    });
  }
}
